import React, { useState } from "react";
import { Container, Form, Button, Alert } from "react-bootstrap";
import "./ContactForm.css";
import image1 from "../assets/pohlertsteinreinigung28.jpeg";

// Hintergrundbild für die Parallax-Seite
const backgroundImage = image1 || "https://dummyimage.com/800x600/ccc/000&text=Ihr+Bild";

const ContactForm = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", message: "", privacy: false });
  const [submitted, setSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("message", formData.message);

    try {
      const response = await fetch("https://pohlertsteinreinigung.de/contact.php", {
        method: "POST",
        body: formDataToSend,
      });

      const result = await response.json();
      if (result.status === "success") {
        setSubmitted(true);
        setErrorMessage("");
        setTimeout(() => setSubmitted(false), 3000);
        setFormData({ name: "", email: "", phone: "", message: "", privacy: false });
      } else {
        setErrorMessage(result.message);
      }
    } catch (error) {
      setErrorMessage("Fehler beim Senden. Bitte versuchen Sie es erneut.");
    }
  };

  return (
    <section id="contact">
    <div className="contact-section" >
      {/* Linke Seite mit Parallax-Bild */}
      <div className="contact-image" style={{ backgroundImage: `url(${backgroundImage})` }} />

      {/* Rechte Seite mit Kontaktformular */}
      <div className="contact-form-container">
        <Container>
          <h2 className="text-white">Jetzt kostenlose Anfrage senden</h2>

          {submitted && <Alert variant="success">Nachricht erfolgreich gesendet!</Alert>}
          {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

          <Form onSubmit={handleSubmit} className="contact-form">
            <Form.Group controlId="name">
              <Form.Label className="text-white">Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Ihr Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="email" className="mt-3">
              <Form.Label className="text-white">E-Mail *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Ihre E-Mail"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="phone" className="mt-3">
              <Form.Label className="text-white">Telefon</Form.Label>
              <Form.Control
                type="text"
                name="phone"
                placeholder="Telefonnummer"
                value={formData.phone}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="message" className="mt-3">
              <Form.Label className="text-white">Nachricht</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="message"
                placeholder="Was können wir für Sie tun?"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="privacy" className="mt-3">
              <Form.Check
                type="checkbox"
                name="privacy"
                label={<span className="text-white">Ich akzeptiere die <a href="/datenschutz" className="text-warning">Datenschutzerklärung</a>.</span>}
                checked={formData.privacy}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-3 w-100">
              Anfrage senden
            </Button>
          </Form>

          <div className="contact-info mt-4">
            <p className="text-white">
              📞 <strong>+49 1575 49 29 865</strong>
            </p>
            <p className="text-white">
              ✉️ <a href="mailto:pohlertsteinreinigung@gmail.com" className="text-warning">pohlertsteinreinigung@gmail.com</a>
            </p>
          </div>
        </Container>
      </div>
    </div>
    </section>
  );
};

export default ContactForm;
